import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Ruta',
  time: 'Hace 2 minutos'
}, {
  name: 'Lucía F.',
  location: 'MTB',
  time: 'Hace 5 minutos'
}, {
  name: 'Diego R.',
  location: 'Gravel',
  time: 'Hace 12 minutos'
}, {
  name: 'Martín S.',
  location: 'Ruta',
  time: 'Hace 18 minutos'
}, {
  name: 'Valeria P.',
  location: 'MTB',
  time: 'Hace 25 minutos'
}];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    let hideTimer: NodeJS.Timeout;
    let showTimer: NodeJS.Timeout;
    if (isVisible) {
      // Hide after 5 seconds
      hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    } else {
      // Show next after 15-25 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, nextDelay);
    }
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, [isVisible]);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-404">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-405">
          <div className="bg-[#faf7f2] border border-[#e7dfce] rounded-xl shadow-xl p-4 pr-10 relative flex items-start gap-3" data-id="element-406">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-[#6b6358] hover:text-[#1f1b16]" data-id="element-407">
              <X size={16} data-id="element-408" />
            </button>

            <div className="bg-[#7c3aed]/10 p-2 rounded-full shrink-0 mt-0.5" data-id="element-409">
              <CheckCircle2 size={20} className="text-[#7c3aed]" data-id="element-410" />
            </div>

            <div data-id="element-411">
              <p className="text-xs text-[#5b21b6] font-black mb-1 uppercase tracking-wider" data-id="element-412">
                Compra verificada
              </p>
              <p className="text-sm text-[#1f1b16] leading-tight mb-1 font-medium" data-id="element-413">
                <span className="font-black" data-id="element-414">{currentPurchase.name}</span> (
                {currentPurchase.location}) compró Botiquín Vibracional Pro 🎵
              </p>
              <p className="text-xs text-[#6b6358] font-bold" data-id="element-415">
                {currentPurchase.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}